

/**
 * @class
 * DeviceProfile model
 */
export default class DeviceProfile {

    /**
     * @constructor
     * @param {String} id Device profile id
     * @param {Date} createTimestamp Device profile create timestamp
     * @param {String} technology Device profile technology
     * @param {Object} context Device profile context data 
     * @param {String} converter Device profile converter logic string
     */
    constructor(
      id,
      createTimestamp,
      technology,
      context,
      converter
    ){ 
      this._id = id
      this._createTimestamp = createTimestamp
      this._technology = technology
      this._context = context
      this._converter = converter
    }

    get id(){
      return this._id
    }
    set id(id){
      this._id = id
    }

    get createTimestamp(){
      return this._createTimestamp
    }
    set createTimestamp(createTimestamp){
        this._createTimestamp = createTimestamp
    }

    get technology(){
      return this._technology
    }
    set technology(technology){
        this._technology = technology
    }

    get context(){
        return this._context
      }
    set context(context){
        this._context = context
    }

    get converter(){
      return this._converter
    }
    set converter(value){
        this._converter = value
    }
  }